/* eslint-disable react/jsx-curly-brace-presence */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  Toolbar,
  Fab,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { withRouter, Route, Switch } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import {
  Group,
  LockOutlined,
  Storage,
  AccountBalance,
  LibraryBooks,
  EventNote,
} from '@material-ui/icons';
import Icon from '@material-ui/core/Icon';
import Hidden from '@material-ui/core/Hidden';
import { connect } from 'react-redux';
import { ReactComponent as Logo } from '../../components/header/logo.svg';
import UserOverview from './users';
import EditUser from './users/edit-user';
import InfoUser from './users/info-user';
import AddUser from './users/add-user';
import { doFetch } from '../../services/fetch/fetch.actions';
import { fetchProfile, fetchRole } from '../../services/politician/profile-service';
import PartyOverview from './parties/overview';
import CommitteeOverview from './committees/overview';
import PartyMembers from './parties/politicians-in-party';
import CommitteeMembers from './committees/users-in-committee';
import PartyHistory from './history/party-history';
import CommitteeHistory from './history/committee-history';
import * as userConstants from './users/functions/constants';

const menuItems = [
  {
    icon: Group,
    text: 'Brukere',
    path: '/admin/users',
    comp: UserOverview,
  },
  {
    icon: Storage,
    text: 'Partier',
    path: '/admin/partier',
    comp: PartyOverview,
  },
  {
    icon: LibraryBooks,
    text: 'Historikk partier',
    path: '/admin/historikk-parti',
    comp: PartyHistory,
  },
  {
    icon: AccountBalance,
    text: 'Utvalg',
    path: '/admin/utvalg',
    comp: CommitteeOverview,
  },
  {
    icon: EventNote,
    text: 'Historikk utvalg',
    path: '/admin/historikk-utvalg',
    comp: CommitteeHistory,
  },
];

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoutopen: false,
    };
  }

  componentDidMount() {
    const {
      profile: { fetched, fetching },
      dispatch, me: { fetched: meFetched, fetching: meFetching },
    } = this.props;
    if (!fetched && !fetching) {
      dispatch(doFetch('PROFILE', fetchProfile().then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })));
    }
    if (!meFetched && !meFetching) {
      dispatch(doFetch('ME', fetchRole().then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })));
    }
  }

  render() {
    const {
      classes, history, history: { location: { pathname } },
      profile: {
        payload: fetched
      },
      me: { fetched: meFetched, payload: me },
    } = this.props;
    const { logoutopen } = this.state;

    if (meFetched && (me.active !== userConstants.ENABLED || !me.roles
      || (me.roles && !(me.roles.includes('admin') || me.roles.includes('superadmin'))))) {
      window.location = `${window.location.origin}/#/no-access`;
    }

    return (
      <div className={classes.root}>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="left"
        >
          <Toolbar className={classes.toolbar} onClick={() => history.push('/admin')}>
            <Icon className={classes.logo} color="inherit" aria-label="Menu">
              <Logo />
            </Icon>
            <Hidden smDown>
              <div className={classes.grow}>
                <Typography variant="subtitle1" color="inherit">
                  Trondheim kommune
                </Typography>
                <Typography color="inherit" variant="subtitle2">
                  Politikerbasen (Admin)
                </Typography>
              </div>
            </Hidden>
          </Toolbar>
          <Divider />
          <List>
            {menuItems.map(({ icon: MenuEntryIcon, text, path }) => {
              const selected = pathname === path
                || pathname.includes(path)
                || ((pathname === '/admin' || pathname === '/admin/') && path === '/admin/users');
              return (
                <ListItem
                  selected={selected}
                  key={path}
                  onClick={() => history.push(path)}
                  button
                >
                  <ListItemIcon className={classes.navItemIcon}>{<MenuEntryIcon color={selected ? 'primary' : 'inherit'} />}</ListItemIcon>
                  <Hidden smDown>
                    <ListItemText
                      primary={text}
                      primaryTypographyProps={{
                        className: selected ? classes.selectedmenutext : classes.menutext,
                      }}
                    />
                  </Hidden>
                </ListItem>
              );
            })}
          </List>
          <div className={classes.bottom}>
            <Hidden smDown>
              <Divider />
              <div className={classes.buttonbox}>
                <div className={classes.flex}>
                  {fetched && meFetched && (
                    <Typography
                      variant="body1"
                      color="primary"
                      gutterBottom
                      onClick={() => me.roles && (me.roles.includes('admin') || me.roles.includes('superadmin'))
                         && history.push(`/admin/users/endre-${me.id}`)}
                    >
                      {`${me.givenName} ${me.familyName}`}
                    </Typography>
                  )}
                  <Typography variant="subtitle2" color="textSecondary">
                    Logget inn
                  </Typography>
                </div>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  className={classes.login}
                  onClick={() => { this.setState({ logoutopen: true }); }}
                >
                  <LockOutlined className={classes.personicon} color="primary" />
                  Logg ut
                </Button>
              </div>
            </Hidden>
          </div>
          <Hidden mdUp>
            <Fab size="small" className={classes.loginIcon} color="primary" onClick={() => this.setState({ logoutopen: true })}>
              <LockOutlined />
            </Fab>
          </Hidden>
          <Dialog key="dialog" open={logoutopen}>
            <DialogTitle>Ønsker du å logge ut?</DialogTitle>
            <DialogActions>
              <Button onClick={() => this.setState({ logoutopen: false })} color="primary">
                Avbryt
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  window.location = `/idp-auth/self-log-me-out?post_logout_redirect_uri=${window.location.origin.replace('admin', '')}/`;
                }}
                color="primary"
              >
                Logg ut
              </Button>
            </DialogActions>
          </Dialog>
        </Drawer>
        <div className={classes.content}>
          <Switch>
            <Route exact path="/admin/users" component={UserOverview} />
            <Route path="/admin/users/endre-:id" component={EditUser} />
            <Route path="/admin/users/id-:id" component={InfoUser} />
            <Route exact path="/admin/users/leggtil" component={AddUser} />
            <Route exact path="/admin/partier" component={PartyOverview} />
            <Route exact path="/admin/partier/:id" component={PartyMembers} />
            <Route exact path="/admin/utvalg" component={CommitteeOverview} />
            <Route exact path="/admin/utvalg/:id" component={CommitteeMembers} />
            <Route exaxt path="/admin/historikk-parti" component={PartyHistory} />
            <Route exaxt path="/admin/historikk-utvalg" component={CommitteeHistory} />
            <Route path="/admin" component={UserOverview} />
          </Switch>
        </div>
      </div>
    );
  }
}

Admin.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  me: PropTypes.object.isRequired,
};


const fullWidth = '14rem';
const mobileWidth = '3.4rem';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  flex: {
    display: 'flex',
    flexWrap: 'wrap-reverse',
    justifyContent: 'space-between',
  },
  drawer: {
    [theme.breakpoints.up('xs')]: {
      width: fullWidth,
    },
    [theme.breakpoints.down('sm')]: {
      width: mobileWidth,
    },
    flexShrink: 0,
  },
  drawerPaper: {
    [theme.breakpoints.up('xs')]: {
      width: fullWidth,
    },
    [theme.breakpoints.down('sm')]: {
      width: mobileWidth,
    },
  },
  navItemIcon: {
    marginRight: 0,
  },
  toolbar: {
    width: '100%',
    paddingLeft: '0',
    paddingRight: '0',
    justifyContent: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
  logo: {
    width: '3rem',
    height: '3rem',
    marginLeft: '4px',
  },
  grow: {
    flexGrow: 1,
  },
  bottom: {
    width: '100%',
    bottom: 0,
    position: 'absolute',
  },
  buttonbox: {
    margin: '1rem',
    marginTop: '0.5rem',
  },
  loginIcon: {
    bottom: 0,
    position: 'absolute',
    margin: '0.5rem',
  },
  selectedmenutext: {
    color: theme.palette.primary.main,
  },
});

const mapStateToProps = ({ profile, me }) => ({
  profile, me,
});

export default connect(mapStateToProps)(withStyles(styles)(withRouter(Admin)));
